import { HiddenWeekendSchedules, WorkloadData } from './types';
import { lastDayOfMonth, lastDayOfWeek, startOfMonth, startOfWeek } from 'date-fns';

export const getFirstDayOfBusinessWeek = (date: Date): Date =>
  startOfWeek(date, { weekStartsOn: 1 });

export const getLastDayOfBusinessWeek = (date: Date): Date =>
  lastDayOfWeek(date, { weekStartsOn: 1 });

const getFirstDate = (date: Date) => getFirstDayOfBusinessWeek(startOfMonth(date));

const getLastDate = (date: Date) => getLastDayOfBusinessWeek(lastDayOfMonth(date));

export const MONTHLY_LIMIT = 5;
export const TWO_WEEKLY_LIMIT = 10;
export const WEEK_LENGTH = 7;

export const DAY_KEY_FORMAT = 'yyyy-MM-dd';

export const EMPTY_HIDDEN_WEEKEND: HiddenWeekendSchedules = { saturday: 0, sunday: 0 };

export const initialState: WorkloadData = {
  rescheduler: {
    open: false,
    initialDate: undefined,
    job: {},
    task: {},
  },
  visibleDays: 8,
  date: new Date(),
  dates: [],
  calendar: {
    isLoading: true,
    records: [],
    withoutTeam: [],
    drafts: {},
    hiddenCount: 0,
    hiddenForemenCount: 0,
  },
  drawer: {
    add: {
      open: false,
      tab: 'job',
    },
    settings: {
      open: false,
      endpoint: '',
    },
    filters: {
      open: false,
    },
    scheduler: {
      open: false,
      scheduleId: '',
      foremanId: '',
      date: null,
      job: {},
      task: {},
    },
  },
  sidebar: {
    jobs: {
      isLoading: true,
      records: [],
      pagy: null,
      loader: {
        visible: false,
      },
    },
    specialties: {
      isLoading: true,
      records: [],
    },
  },
  isTwoWeekly: false,
  showHidden: false,
  hiddenWeekend: EMPTY_HIDDEN_WEEKEND,
  expandedWeekendDays: [],
  weekColumns: [],
  monthly: {
    records: {},
    drafts: {},
    isLoading: true,
    weekLength: WEEK_LENGTH,
    limit: MONTHLY_LIMIT,
    first: getFirstDate(new Date()),
    last: getLastDate(new Date()),
    dates: [],
    hiddenCount: 0,
    hiddenDaysCount: 0,
  },
};
